import { activityHistoryFiltersSlice } from "../../slice";

export const { deleteDiagnosticFilterValue } = activityHistoryFiltersSlice.actions;
